import { useQuery } from "@tanstack/react-query";
import { useRouteMatch } from "react-router-dom";
import { MeetingRequestService } from "../../../../../services/company-office/MeetingRequest.service";

export const useGetDetailRequests = () => {
  const { id } = useRouteMatch().params as any;

  const response = useQuery({
    queryKey: ["meeting-request-get-detail", id],
    queryFn: () => MeetingRequestService.getMeetingRequest(id),
    refetchOnMount:"always"
  });

  return response;
};